import Illustration from './Illustration';

export { default as Control } from './illustrations/Control';
export { default as Shipped } from './illustrations/Shipped';
export { default as Formats } from './illustrations/Formats';
export { default as SecureSupplyChain } from './illustrations/SecureSupplyChain';
export { default as illustrationMap } from './map';

export default Illustration;
